import molyLogoFull from '@/assets/moly-logo-full.svg'
import molyLogoFullDark from '@/assets/moly-logo-full-dark.svg'
import { cn } from '@/lib/utils'

/**
 * Full "moly." wordmark. The SVG bakes in the wordmark fill, so dark mode
 * swaps to a variant with a light wordmark instead of recolouring via CSS.
 */
export function MolyLogoFull({ className }: { className?: string }) {
  return (
    <>
      <img
        src={molyLogoFull}
        alt="Moly logo"
        className={cn('object-contain dark:hidden', className)}
      />
      <img
        src={molyLogoFullDark}
        alt="Moly logo"
        className={cn('hidden object-contain dark:block', className)}
      />
    </>
  )
}
